var si = typeof setImmediate === 'function', tick;
if (si) {
  tick = function (fn) { setImmediate(fn); };
} else {
  tick = function (fn) { setTimeout(fn, 0); };
}

module.exports = tick;


/*****************
 ** WEBPACK FOOTER
 ** ./~/ticky/ticky-browser.js
 ** module id = 1019
 ** module chunks = 0
 **/